module.exports = __webpack_public_path__ + "img/as_badge.f8982d48.png";